import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Security and Privacy Guide"
      description="For School Leaders and ICT Executives"
      slug={props.location.pathname}
    />
  );
}

function SecurityPrivacyPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Security and Privacy Guide"
        subtitle="For School Leaders and ICT Executives"
        id="SECURITY_GUIDE"
        redirectUrl="https://stileapp.com/go/security-guide"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/security_privacy_guide.png"
            alt=""
          />
        }
      />

      <CtaBlock />
    </PageLayout>
  );
}

export default SecurityPrivacyPage;
